document.querySelectorAll('.block-location-finder-form').forEach((block) => {
	const input = block.querySelector<HTMLInputElement>(
		'.block-location-finder-form__search-input'
	);

	if (input) {
		const toggleValueClass = () => {
			input.classList.toggle(
				'block-location-finder-form__search-input--has-value',
				!!input.value
			);
		};

		toggleValueClass();
		input.addEventListener('input', toggleValueClass);
	}
});
